/**
 *
 * @constructor
 */
function WikiPage() {
    /**
     *
     */
    WikiPage.prototype.initialize = function (console, mesh) {
        this.id = "wiki";
        this.console = console;
        this.mesh = mesh;

        return this;
    };

    /**
     *
     */
    WikiPage.prototype.show = function () {
        var deferred = $.Deferred();

        this.console.consoleService.getPages(this.mesh).done(function (pages) {
            this.pages = pages;

            this.console.safeApply();
        }.bind(this)).fail();

        deferred.resolve();

        return deferred.promise();
    };

    /**
     *
     */
    WikiPage.prototype.leave = function () {
    };
}
